import Vue from 'vue';
import VueRouter from 'vue-router';

import calendarRoutes from '@/router/calendarRoutes';
import tasksRoutes from '@/router/tasksRoutes';
import insightsRoutes from '@/router/insightsRoutes';
import insightsRoutesIntegrations from '@/router/insightsRoutesIntegrations';
import panelRoutes from '@/router/panelRoutes';

const Dashboard = () => import('../pages/insights/Dashboard');
const AuthPage = () => import('../pages/auth/AuthPage');

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    {
      path: '*',
      redirect: '/calendar',
    },
    ...calendarRoutes,
    ...tasksRoutes,
    {
      path: '/insights',
      redirect: '/insights/general_information',
    },
    ...insightsRoutes,
    ...insightsRoutesIntegrations,
    ...panelRoutes,

    {
      path: '/dashboard',
      component: Dashboard,
      meta: {
        layout: 'InsightsLayout',
      },
    },

    {
      path: '/auth',
      component: AuthPage,
      meta: {
        layout: 'AuthLayout',
      },
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
